import script from "./LearningSetupSummaryBooksSection.vue?vue&type=script&setup=true&lang=ts"
export * from "./LearningSetupSummaryBooksSection.vue?vue&type=script&setup=true&lang=ts"

import "./LearningSetupSummaryBooksSection.vue?vue&type=style&index=0&id=0faee4e3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0faee4e3"]])

export default __exports__